import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { TrProgressButton } from './tr-progress-button.class';

@Directive({
    selector: 'button[trProgressButton]',
})
export class TrProgressButtonDirective implements AfterViewInit {

    private nativeElement: any;
    private progressButton: TrProgressButton;

    constructor(
        public element: ElementRef,
        public render: Renderer2,
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    public complete() {
        this.progressButton.complete();
        this.progressButton.stop(0);
    }

    public completeWithErrors() {
        this.progressButton.complete();
        this.progressButton.stop(-200);
    }

    public startLoadingState() {
        this.progressButton.start();
    }

    public ngAfterViewInit() {
      this.progressButton = new TrProgressButton( this.nativeElement, {
            callback: (instance) => {
                let progress = 0;
                const interval = setInterval(() => {
                    progress = Math.min( progress + 0.01, 0.94 );
                    instance.setProgress( progress );
                    if ( progress === 0.94 ) {
                        clearInterval( interval );
                        // instance._stop(1);
                    }
                }, 50);
            },
        } );
    }
}
